@if (crew) {
<fieldset style="border: 0"
  [disabled]="crewChange?.isCancelled || !hasRole('vessels-crew-change-editor')">
  <div class="row">
    <div class="col-12 col-md-3 mb-3">
      <form #CrewChange="ngForm">
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="text-center m-4">
              <app-material-image-viewer
                [documentId]="crew.photoDocumentId || '' "
                [alt]="crew?.firstName"
                class="round-photo img-fluid">
              </app-material-image-viewer>
            </div>
            <div class="text-center">
              <h5 class="mt-1 fw-bold pb-2">
                {{ crew.firstName }} {{ crew.middleName }} {{ crew.lastName }}
              </h5>
            </div>
            <app-material-auto-complete
              name="rank"
              id="rank"
              class="row text-center px-2"
              [formatter]="rankFormatter"
              [(ngModel)]="crewChange.rank"
              placeholder="Position/Rank"
              [items]="ranks"
              [required]="true">
            </app-material-auto-complete>
            <app-material-pg-input
              type="text"
              name="userName"
              id="userName"
              class="row text-center mx-2"
              [disabled]="true"
              [(ngModel)]="crew.ssoUsername"
              label="SSO Username">
            </app-material-pg-input>
            <app-material-auto-complete
              name="vessel"
              id="vessel"
              class="row text-center px-2 pb-2"
              placeholder="Vessel"
              [formatter]="vesselFormatter"
              [(ngModel)]="selectedVessel"
              (ngModelChange)="selectVessel($event)"
              [disabled]="!!crewChangeId"
              [items]="vessels"
              [required]="true">
            </app-material-auto-complete>
            <app-material-auto-complete
              id="voyage"
              name="voyage"
              class="row text-center px-2 pb-2"
              placeholder="Voyage NO"
              [formatter]="voyageFormatter"
              [(ngModel)]="selectedVoyage"
              [disabled]="!voyages || !!crewChangeId"
              [items]="voyages"
              [required]="true">
            </app-material-auto-complete>
            <div>
              <app-material-pg-button
                class="pull-right me-2"
                id="save"
                [disabled]="!CrewChange.form.valid"
                (clicked)="addNewCrewChange()"
                label="save">
              </app-material-pg-button>
              @if(!crew.ssoUsername){
              <app-material-pg-button
                class="pull-right me-2"
                id="sso"
                [disabled]="!CrewChange.form.valid"
                (clicked)="suggestUsername()"
                label="Assign Username">
              </app-material-pg-button>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    </div>
    <div class="col-12 col-md-5 mb-3">
      <form class="form-horizontal"
        #CrewChange="ngForm">
        <mat-card>
          <mat-card-content>
            @if (
            crewChange?.id && crewChange?.id !==
            '00000000-0000-0000-0000-000000000000') {
            <div>
              <app-crew-change-plans
                [crewChange]="crewChange"
                (saved)="update()">
              </app-crew-change-plans>
            </div>
            }
            @if (selectedCrewPreviousAssignments?.length > 0) {
            <div class="mt-4">
              <mat-card>
                <mat-card-header>
                  <mat-card-title>Assignments</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="table-responsive">
                    <table class="table table-sm table-striped align-middle">
                      <thead>
                        <tr>
                          <th>Vessel</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Rank</th>
                          <th>Duration</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (ch of selectedCrewPreviousAssignments; track $index) {
                        <tr>
                          <td>
                            <a
                              [routerLink]="['/vessels/crew-change/crew-change-data-entry/',ch.id]">{{ch.vesselName}}</a>
                          </td>
                          <td>{{extractDateTime(crewChangeFindPlan(ch,
                            "On Board"))}}</td>
                          <td>{{extractDateTime(crewChangeFindPlan(ch,
                            "Off Board"))}}</td>
                          <td>{{ ch.rank }}</td>
                          <td>{{ duration(ch) }}</td>
                          <td>{{ ch.isCancelled ? "Cancelled" : "" }}</td>
                        </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            }
          </mat-card-content>
        </mat-card>
      </form>
    </div>
    <div class="col-12 col-md-4 mb-3">
      <form>
        <mat-card>
          <mat-card-content>
            @if (crewChange?.id &&crewChange?.id !==
            '00000000-0000-0000-0000-000000000000') {
            <div>
              <app-crew-contract
                [selectedCrewContract]="crewChange.contract!"
                (saveCrewContract)="updateContract($event)">
              </app-crew-contract>
            </div>
            }
          </mat-card-content>
        </mat-card>
      </form>
    </div>
  </div>
</fieldset>
}